(function () {
  'use strict';

  angular
    .module('wbAccount.wbCompany')
    .config(config);

  function config() {
  }
}());
